import { TranslationMapKey } from '../enums';
import { IField, IPagedResponse, SortDirection } from '../shared/interfaces';

export interface ITableSettings {
    sort: ISortData;
    page: IPageData;
}

export interface ITableData<RowData extends {} = any> {
    columns?: IField[];
    rowObjects: RowData[];
    pagedResponse: IPagedResponse;
    sortData?: ISortData;
}

export interface ITableRow<RowData extends {} = any> {
    object: RowData;
    cells: ITableBodyCell[];
    actionItems: IRowActionItem[];
}

export interface ITableBodyCell {
    text: string;
    cssClass?: string;
}

export interface ITableHeaderCell {
    text: string;
    cssClass?: string;
}

export interface IPageData {
    offset: number;
    limit: number;
}

export interface ISortData {
    fieldName: string;
    sortDirection: SortDirection;
}

export type IRowActionItemActionFn<RowData extends {}> = (row: RowData) => void;

export interface IRowActionItem<RowData extends {} = any> {
    label: TranslationMapKey | (string & {});
    actionFn: IRowActionItemActionFn<RowData>;
}

export type IRowActionObject<RowData extends {} = any> = {
    viewFn?: IRowActionItemActionFn<RowData>
    otherActions?: IRowActionItem[]
}

export type IRowActionGetter<RowData extends {} = any> = (row: RowData) => IRowActionObject<RowData>;

export const getRowActionItems = <RowData extends {} = any>(row: RowData, getter: IRowActionGetter<RowData> | undefined): IRowActionItem<RowData>[] => {
    if (!getter) {
        return [];
    }
    const actionItems: IRowActionItem[] = [];
    const actionObject = getter(row);

    if (actionObject.viewFn) {
        actionItems.push({
            actionFn: actionObject.viewFn,
            label: 'VIEW',
        });
    }
    actionItems.push(...actionObject.otherActions || []);

    return actionItems;
};
